import { Icon, ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import React from 'react';
import { ImageStyle, StyleProp, StyleSheet, View } from 'react-native';

interface Props {
  children?: string | React.ReactElement;
  iconSource?: ICONS;
  color?: string;
  fontColor?: string;
  accessibilityLabel?: string;
  iconStyle?: StyleProp<ImageStyle>;
  size?: 'normal' | 'small';
}

export const Chip: React.FC<Props> = ({
  accessibilityLabel,
  children,
  color,
  fontColor,
  iconSource,
  iconStyle,
  size,
}: Props) => (
  <View accessibilityLabel={accessibilityLabel} style={styles.viewStyle}>
    {!!iconSource && (
      <Icon
        source={iconSource}
        size={size === 'small' ? 12 : 17}
        color={color || 'black'}
        style={iconStyle}
      />
    )}
    {!!children &&
      (typeof children === 'string' ? (
        <View style={styles.children}>
          <Txt
            weight="bold"
            size="xxxsmall"
            numberOfLines={1}
            style={[
              fontColor ? { color: fontColor } : null,
              { overflow: 'visible' },
            ]}
            lineHeightNone
          >
            {children}
          </Txt>
        </View>
      ) : (
        <View style={styles.children}>{children}</View>
      ))}
  </View>
);

const styles = StyleSheet.create({
  children: {
    marginHorizontal: 4,
    maxWidth: 200,
  },
  viewStyle: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginRight: 4,
    paddingTop: 6,
    overflow: 'hidden',
  },
});
